<template>
    <div v-if="show" class="dialog-content">
        <div class="product-detail">
            <div class="picture-container">
                <img v-if="SelectedAttrImgUrl" :src="SelectedAttrImgUrl" :alt="productName" />
                <img v-else src="@/assets/images/default.png" :alt="productName" />
            </div>
            <div class="attr-container">
                <div class="name-container">{{ productName }}</div>
                <el-form class="product-form" label-width="68px" ref="productDetailForm" :model="productForm">
                    <el-form-item class="price-row" :label="$t('cart.dialogPrice')">
                        <el-input size="small" v-model="productForm.skuPrice"></el-input>
                    </el-form-item>
                    <div class="specification-container">
                        <div class="attr-row" v-for="(item, index) in specificationList" :key="index">
                            <div class="attr-label">{{ specLabel(item) }}</div>
                            <div class="attr-values">
                                <button type="button" class="attr-tag" :class="{ 'attr-tag-checked': item2.checked === '1' }"
                                    :aria-pressed="item2.checked === '1'" v-for="(item2, index2) in item.value"
                                    @click="tagClick(item2, item)" :key="index2">{{ item2.name }}</button>
                            </div>
                        </div>
                    </div>
                    <el-form-item class="quantity-row" :label="$t('cart.dialogQuantity')">
                        <el-input-number controls-position="right" :min="0" v-model="productForm.quantity" size="small"></el-input-number>
                    </el-form-item>
                </el-form>
                <div class="dialog-actions">
                    <el-button class="action-button action-cancel" @click="goodsCancel">{{ $t('cancel') }}</el-button>
                    <el-button v-if="!isAddMode" class="action-button action-confirm" @click="goodsSave">{{ $t('cart.confirmEdit') }}</el-button>
                    <el-button class="action-button action-add" @click="addToCart">{{ $t(isAddMode ? 'orderList.addCart' : 'cart.addToNewRow') }}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        isAddMode: {
            type: Boolean,
            default: false
        },
        subProps: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        subProps: {
            handler(val) {
                console.log('-subProps', val)
                if (val?.url) {
                    this.initDom()
                }
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            show: false,
            SelectedAttrImgUrl: undefined,
            specificationList: [],
            productForm: {
                skuPrice: '',
                quantity: '1'
            },
            pullSize: '',
            pullName: '',
            productName: '',
            /*商品sku表*/
            productArray: [],
            selectedSku: {},
            offerId: '',
            sellerOpenId : '',
            allowSave: false,
        }
    },
    created() {
        console.log('create', this.subProps)
    },
    mounted() {

    },
    methods: {
        specLabel(item) {
            if (item.colorFlag == 1) return this.$t('cart.dialogColor')
            if (item.colorFlag == 0) return this.$t('cart.dialogSize')
            return `${item.name}：`
        },
        resetData() {
            this.specificationList = []
            this.productName = ''
            this.pullName = ''
            this.pullSize = ''
            this.productArray = []
            this.selectedSku = {}
            this.allowSave = false
            this.SelectedAttrImgUrl = undefined
            this.productForm = {
                skuPrice: '',
                quantity: '1'
            }
            this.offerId =  '';
            this.sellerOpenId =  '';
        },
        async initDom() {
            this.resetData()
            const { url, row = {} } = this.subProps
            const res = await this.$http.get('order/getGoodsInfo', { params: { url: url } });
            const { data = {}, code, message } = res.data
            if (code === 200) {
                this.productName = data.title
                this.specificationList = data.specificationList;
                this.pullSize = this.specificationList.some((item) => item.colorFlag == 0)
                    ? this.specificationList.find((item) => item.colorFlag == 0).name
                    : this.specificationList.some((item) => item.colorFlag == 2)
                        ? this.specificationList.find((item) => item.colorFlag == 2).name
                        : '';
                this.pullName = this.specificationList.some((item) => item.colorFlag == 1)
                    ? this.specificationList.find((item) => item.colorFlag == 1).name
                    : this.specificationList.some((item) => item.colorFlag == 2)
                        ? this.specificationList.find((item) => item.colorFlag == 2).name
                        : '';
                this.specificationList.forEach((el) => {
                    el.value.forEach((el2) => {
                        this.$set(el2, 'checked', '0');
                    });
                });
                this.productArray = data.skuList;
                this.SelectedAttrImgUrl = !this.isAddMode && row.pictureUrl ? row.pictureUrl : data.picUrl
                if (!this.productArray || this.productArray.length ===0){
                  this.productForm.skuPrice = data.price
                }
                this.offerId = data?.offerId || ''
                this.sellerOpenId = data?.sellerOpenId || ''
                if (!this.isAddMode) {
                    const matchedSku = Array.isArray(this.productArray) && this.productArray.find((sku) =>
                        (row.skuId && String(sku.sku_id) === String(row.skuId)) ||
                        (row.specId && String(sku.specId) === String(row.specId))
                    )
                    this.specificationList.forEach((item) => {
                        const skuValue = matchedSku && matchedSku.properties_name?.find((property) => property.name === item.name)?.value
                        const rowValue = item.name === this.pullName ? row.colour : item.name === this.pullSize ? row.goodsSize : undefined
                        const selected = item.value.find((option) => option.name === (skuValue || rowValue))
                        if (selected) this.$set(selected, 'checked', '1')
                    })
                }
                this.getSku()
                if (!this.isAddMode) {
                    if (row.price !== null && row.price !== undefined && String(row.price).trim() !== '') {
                        this.productForm.skuPrice = row.price
                    }
                    if (Number(row.goodsCount) > 0) this.productForm.quantity = Number(row.goodsCount)
                }
                this.show = true
            } else {
                this.$message.error(message);
            }

        },
        goodsCancel() {
            this.$emit('update:visible', false)
        },
        // 添加购物车 - 新增一行并回显数据
        addToCart() {
            if (!this.allowSave) {
              console.log(1234)
                this.$message.error(this.$t('createOrder.createOrder125'))
                return
            }
            const { row } = this.subProps
            const goodsInfo = {
                ...row,
                goodsName: this.productName,
                goodsSize: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullSize) ? this.selectedSku.properties_name.find(item => item.name == this.pullSize).value : '',
                colour: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullName) ? this.selectedSku.properties_name.find(item => item.name == this.pullName).value : '',
                goodsCount: this.productForm.quantity,
                price: this.productForm.skuPrice,
                pictureUrl: this.SelectedAttrImgUrl,
                specId: this.selectedSku.specId ? this.selectedSku.specId : '',
                skuId: this.selectedSku.sku_id,
                offerId: this.offerId,
                sellerOpenId: this.sellerOpenId,
            }
            this.$emit('addNewRow', goodsInfo, this.isAddMode)
        },
        // 商品信息保存
        async goodsSave() {
            const { row } = this.subProps
            if (!this.allowSave) {
                this.$message.error(this.$t('createOrder.createOrder125'))
                return
            }
            const goodsInfo = {
                ...row,
                goodsName: this.productName,
                goodsSize: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullSize) ? this.selectedSku.properties_name.find(item => item.name == this.pullSize).value : '',
                colour: this.selectedSku.sku_id && this.selectedSku.properties_name.some(item => item.name == this.pullName) ? this.selectedSku.properties_name.find(item => item.name == this.pullName).value : '',
                specId: this.selectedSku.specId ? this.selectedSku.specId : '',
                goodsCount: this.productForm.quantity,
                price: this.productForm.skuPrice,
                pictureUrl: this.SelectedAttrImgUrl,
                offerId: this.offerId,
                sellerOpenId: this.sellerOpenId,
                skuId: this.selectedSku.sku_id,
            }
            const res = await this.$http.post('shopping/vehicle/update', goodsInfo)
            const { data, code, message } = res.data
            if (code === 200) {
                console.log('data', data)
                this.$emit('onChange', row.id, data)
                this.$emit('update:subProps', {})
                this.$emit('update:visible', false)
            } else {
                this.$message.error(message)
            }
        },
        tagClick(item2, item) {
            if (item.colorcolorFlag == '1') {
                this.isInSmImg = 0;
            }
            item.value.forEach(function (el) {
                el.checked = '0';
            });
            item2.checked = '1';
            //选择颜色，左侧图片联动
            if (item2.url) {
                this.SelectedAttrImgUrl = item2.url;
            }
            this.getSku();
        },
        getSku() {
            let selectskuattrs = [];
            let attrCount = this.specificationList.length;
            let selectAttrCount = 0;
            if (!attrCount) {
                this.allowSave = true;
                return;
            }
            this.specificationList.forEach(item => {
                item.value.forEach(item2 => {
                    if (item2.checked == '1') {
                        selectAttrCount++;
                        selectskuattrs.push({
                            name: item.name,
                            value: item2.name
                        });
                    }
                });
            });
          console.log(attrCount)
          console.log(selectAttrCount)
            if (attrCount == selectAttrCount) {

              //是否可选
               let isSelect = false
              if (!this.productArray){
                isSelect = true
                this.productArray = []
              }
                this.productArray.forEach(item => {
                  let properties = [...item.properties_name]
                  let selectsku = [...selectskuattrs]
                  properties.sort((a, b) => a.name.localeCompare(b.name));
                  selectsku.sort((a, b) => a.name.localeCompare(b.name));
                  console.log(JSON.stringify(properties))
                  console.log(JSON.stringify(selectsku))
                  if (JSON.stringify(properties) === JSON.stringify(selectsku)) {
                    console.log(item)
                        this.selectedSku = item;
                        this.productForm.skuPrice = item.price;
                        isSelect = true
                        //_this.productForm.quantity = el.quantity;
                    }
                });

                if (isSelect) {
                    this.allowSave = true
                }

               if (!isSelect){
                 this.allowSave = false
                 this.selectedSku = {}
                 this.productForm.skuPrice = ''
               }
            } else {
                this.allowSave = false
            }
        },
    },
}
</script>
<style scoped>
.dialog-content {
    color: #344054;
}

.product-detail {
    display: grid;
    grid-template-columns: minmax(190px, 30%) minmax(0, 1fr);
    gap: 28px;
    align-items: start;
}

.picture-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-width: 0;
}

.picture-container img {
    display: block;
    width: 180px;
    height: 190px;
    max-width: 100%;
    object-fit: contain;
}

.attr-container {
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 210px;
}

.name-container {
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.5;
    color: #344054;
}

::v-deep .product-form .el-form-item {
    margin-bottom: 8px !important;
}

::v-deep .product-form .el-form-item__label {
    color: #667085;
    font-size: 13px;
    text-align: left;
}

.price-row ::v-deep .el-input {
    max-width: 480px;
}

.price-row ::v-deep .el-input__inner {
    height: 34px;
    border-color: #d6dee8;
}

.attr-row {
    display: grid;
    grid-template-columns: 68px minmax(0, 1fr);
    align-items: start;
    min-height: 32px;
    margin: 7px 0;
}

.attr-label {
    padding-top: 7px;
    color: #667085;
    font-size: 13px;
}

.attr-values {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.attr-tag {
    min-height: 32px;
    padding: 4px 10px;
    border: 1px solid #d6dee8;
    border-radius: 4px;
    background: #fff;
    color: #475467;
    font: inherit;
    font-size: 13px;
    line-height: 1.4;
    cursor: pointer;
}

.attr-tag:hover,
.attr-tag:focus-visible {
    border-color: #1682ee;
    outline: none;
}

.attr-tag-checked,
.attr-tag-checked:hover {
    border-color: #1682ee;
    background: #eaf4ff;
    color: #0874d4;
}

.quantity-row ::v-deep .el-input-number {
    width: 120px;
}

.dialog-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 14px;
    margin-top: auto;
    padding-top: 8px;
}

.dialog-actions .el-button {
    min-width: 145px;
    height: 40px;
    margin-left: 0;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
}

.action-cancel {
    border-color: #b9c5d1;
    background: #f6f8fb;
    color: #344054;
}

.action-confirm {
    border-color: #0874d4;
    background: #0874d4;
    color: #fff;
}

.action-add {
    border-color: #4fa760;
    background: #4fa760;
    color: #fff;
}

.action-confirm:hover,
.action-confirm:focus {
    border-color: #0968bd;
    background: #0968bd;
    color: #fff;
}

.action-add:hover,
.action-add:focus {
    border-color: #438f52;
    background: #438f52;
    color: #fff;
}

@media (max-width: 760px) {
    .product-detail {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .picture-container img {
        height: 160px;
    }

    .attr-container {
        min-height: 0;
    }

    .dialog-actions .el-button {
        flex: 1 1 120px;
        min-width: 0;
    }
}
</style>
